import { render, staticRenderFns } from "./recommendItem.vue?vue&type=template&id=8f398528&scoped=true&"
import script from "./recommendItem.vue?vue&type=script&lang=js&"
export * from "./recommendItem.vue?vue&type=script&lang=js&"
import style0 from "./recommendItem.vue?vue&type=style&index=0&id=8f398528&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8f398528",
  null
  
)

export default component.exports